module.exports = __webpack_public_path__ + "img/pr-8.e06273ba.png";